import { useState } from "react";

import { Button, Input } from "@web-app/components";

type ChecklistQuantityProps = {
  onChange: (quantity: number | undefined) => void;
  quantity?: number;
};

// Quantity is opt-in per checklist item: a "+ Qty" link until it's used, then
// a number box with a button to remove the quantity again. What's shown comes
// from `quantity`, so rows stay correct when items are added or removed.
export default function ChecklistQuantity({
  onChange,
  quantity,
}: ChecklistQuantityProps) {
  // Holds what's typed while it isn't a valid quantity yet (e.g. a cleared
  // box), so clearing the box doesn't remove the quantity mid-edit.
  const [draft, setDraft] = useState<string | null>(null);

  if (!quantity && draft === null) {
    return (
      <Button
        plain
        size="2xs"
        className="shrink-0 whitespace-nowrap text-gray-500"
        onClick={() => onChange(1)}
      >
        + Qty
      </Button>
    );
  }

  return (
    <div className="flex shrink-0 items-center gap-1">
      <span className="text-xs text-gray-500">x</span>
      <div className="w-12">
        <Input
          type="number"
          size="xs"
          min={1}
          aria-label="Quantity"
          value={draft ?? String(quantity)}
          onChange={(value: string) => {
            const next = parseInt(value);
            if (next > 0) {
              setDraft(null);
              onChange(next);
            } else {
              setDraft(value);
            }
          }}
          onBlur={() => setDraft(null)}
        />
      </div>
      <Button
        plain
        size="2xs"
        className="!p-1 text-gray-500"
        iconClassName="!h-2.5 !w-2.5"
        icon="fasMinus"
        aria-label="Remove quantity"
        title="Remove quantity"
        onClick={() => {
          setDraft(null);
          onChange(undefined);
        }}
      />
    </div>
  );
}
